export default __webpack_public_path__ + "static/media/gallery-wip-emitter_05.b5bad533.jpg";